import { NextSeo } from "next-seo";

import SectionShell from "components/Section-Shell";

import ContactForm from "elements/Contact-Form";
import DaishoVsAutoML from "elements/Auto-ML/Daisho-vs-Auto-ML";

const VsAutoML = () => (
  <>
    <NextSeo
      title="Daisho vs Auto-ML"
      description="Daisho was built ground-up with BUSINESS USERS in mind."
      canonical="https://www.daisho.ml/vs-auto-ml"
    />
    <SectionShell
      heading="Daisho vs Auto-ML"
      subtitle="Built ground-up with BUSINESS USERS in mind"
    >
      <DaishoVsAutoML />
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div
          className="pt-12 pb-12"
          data-aos="zoom-y-out"
          data-aos-delay={900}
          data-aos-anchor="#technology"
        >
          <ContactForm
            page="Auto-ML"
            heading="Interested in knowing more?"
            subtitle="Drop us a note. We shall setup a time!"
          />
        </div>
      </div>
    </SectionShell>
  </>
);

export default VsAutoML;
